import React from 'react';
import { RiskRatingIcon, SkeletonWrapper } from './LinkedThirdparties.styles';
import { Icon, Tooltip } from 'components/atoms';
import { ScreeningRiskSummary } from '../screening-risks/config';
import { useFetch } from 'hooks';
import { useAuth } from 'auth';
import { LinkedThirdPartyScreeningFindingsResponse } from 'types/responses/thirdParty/linkedThirdPartyScreeningFindingsResponse';
import { useConfig } from 'config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type LinkedThirdPartyScreeningFindingsProps = {
  thirdPartyId: string;
  type: string;
};

const LinkedThirdPartyScreeningFindings: React.FC<LinkedThirdPartyScreeningFindingsProps> = ({
  thirdPartyId,
  type,
}) => {
  const { tokenInfo } = useAuth();
  const { vantageWebApi } = useConfig();
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokenInfo.accessToken}`,
  };
  const { data: screeningFindings, loading: screeningFindingsLoading } =
    useFetch<LinkedThirdPartyScreeningFindingsResponse>(
      `${vantageWebApi}/thirdParty/${thirdPartyId}/screening-findings`,
      { method: 'GET', headers }
    );

  if (screeningFindingsLoading) {
    return (
      <Skeleton
        width="100%"
        height={30}
        duration={2}
        wrapper={SkeletonWrapper}
        baseColor="transparent"
        highlightColor="#CACDCD"
      />
    );
  }

  return (
    <>
      <RiskRatingIcon
        aria-label="Watchlist"
        risk={screeningFindings?.watchlistNotesRiskScore || 'Unknown'}
      >
        <Tooltip tooltipText={ScreeningRiskSummary.WatchList} placement="bottom" trigger="click">
          <Icon icon="sanctions" aria-hidden />
        </Tooltip>
      </RiskRatingIcon>
      <RiskRatingIcon
        aria-label="Enforcements"
        risk={screeningFindings?.enforcementsNotesRiskScore || 'Unknown'}
      >
        <Tooltip tooltipText={ScreeningRiskSummary.Enforcement} placement="bottom" trigger="click">
          <Icon icon="enforcements" aria-hidden />
        </Tooltip>
      </RiskRatingIcon>
      <RiskRatingIcon
        aria-label="Adverse Media"
        risk={screeningFindings?.adverseNotesRiskScore || 'Unknown'}
      >
        <Tooltip tooltipText={ScreeningRiskSummary.AdverseMedia} placement="bottom" trigger="click">
          <Icon icon="adverseMedia" aria-hidden />
        </Tooltip>
      </RiskRatingIcon>
      <RiskRatingIcon
        aria-label="Political Exposure"
        risk={screeningFindings?.politicalNotesRiskScore || 'Unknown'}
      >
        <Tooltip
          tooltipText={ScreeningRiskSummary[`PoliticalExposure${type}`]}
          placement="bottom"
          trigger="click"
        >
          <Icon icon="political" aria-hidden size="xxs" />
        </Tooltip>
      </RiskRatingIcon>
    </>
  );
};

export default LinkedThirdPartyScreeningFindings;
